import React from "react";

// import { Footer, Blog, Possibility, Features, WhatPersbeTech, Header } from './containers';
import {
  Footer,
  Projects,
  Contact,
  Features,
  WhatPersbeTech,
  Header,
} from "./containers";
// import { CTA, Brand, Navbar } from './components';
import { Brand, Navbar } from "./components";
// import { Route, Routes } from "react-router-dom";

import "./App.css";

const MainPg = () => {
  return (
    <div className="App">
      <div className="gradient__bg">
        <Navbar />
        <Header />
      </div>
      <WhatPersbeTech />
      <Features />
      <Projects />
      {/* <CTA/> */}
      <Brand />
      <Contact />
      <Footer />
    </div>
  );
};

export default MainPg;
